
export type config = {
	base: {
		shape: string,
		presetShape: string,
		primitives: {},
	},
	drillholes: {
		type: string,
		edgeType?: string,
		offset?: number,
		diameter?: number,
		settings?: {}[],
		amount?: number,
		position?: {},
		radialDiameter?: number,
		amountHorizontal?: number,
		amountVertical?: number,
	},
	cutouts: {
		type: string,
		shape: string,
		primitives: {},
		modifiers: {
			use_individual_corners?: boolean,
		}|[],
		position: {},
	}[]
};

export abstract class AbstractPreset {
	abstract getConfig(): config;
	abstract getName(): string;

	hasCutouts(): boolean {
		return this.getConfig().cutouts.length > 0;
	}

	hasDrillholes(): boolean {
		return this.getConfig().drillholes.type !== "none";
	}

	// Used to check if shapes are enabled for current product
	getShapes(): string[] {
		const shapes = [];
		shapes.push(this.getConfig().base.shape);

		if(this.hasCutouts()) {
			this.getConfig().cutouts.forEach(cutout => shapes.push(cutout.shape));
		}

		return shapes;
	}
}
